import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  MeasureIcon,
} from '@frontend/legacy-components';

type DxfInterrogationViewBannerProps = {
  onDone: () => void;
};

/**
 * Shown under the toolbar while the viewer is in `interrogation` mode; "Done"
 * leaves the mode.
 */
export const DxfInterrogationViewBanner = ({
  onDone,
}: DxfInterrogationViewBannerProps) => (
  <Alert
    status="info"
    w="auto"
    alignItems="center"
    py="calc(0.5rem - 1px)"
    /* Takes pointer events back from the pass-through band around the toolbar. */
    pointerEvents="auto"
    data-testid="dxf-interrogation-view-banner"
  >
    <AlertIcon as={MeasureIcon} marginEnd={1} />
    <AlertTitle marginEnd={3}>Viewing interrogation results</AlertTitle>
    <Button variant="secondary" size="md" onClick={onDone}>
      Done
    </Button>
  </Alert>
);
DxfInterrogationViewBanner.displayName = 'DxfInterrogationViewBanner';
